export default "__VITE_ASSET__BK3q_DeD__"